<template>
  <div v-if="functions">
    <div
      v-for="(func, funcIndex) in functions"
      :key="funcIndex"
      class="table-row"
    >
      <div class="func-name">
        <P class="label aisea-text-16-600-black">{{ func.name }}</P>
        <P class="description aisea-text-12-400-gray">{{ func.description }}</P>
      </div>
      <div
        class="item button-component"
        v-for="(action, actionIndex) in func.actions"
        :key="actionIndex"
      >
        <ButtonComponent
          :icon="action.button.icon"
          :label="action.button.label"
          :disabled="isButtonDisabled(action)"
          :disabledReason="'APIが設定されていません。'"
          @click="openDialog(action)"
        />
      </div>
    </div>

    <DialogComponent
      v-if="currentDialog"
      :dialog="currentDialog"
      @close="closeDialog"
      @accept="onAccept"
    />
  </div>
</template>

<script>
// Component
import ButtonComponent from "./ButtonComponent.vue";
import DialogComponent from "./DialogComponent.vue";

export default {
  name: "DynamicTable",
  components: {
    ButtonComponent,
    DialogComponent,
  },
  props: {
    functions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentDialog: null,
      currentProcess: null,
      currentDialogComponents: null,
      disabledReason: "",
    };
  },
  methods: {
    openDialog(action) {
      this.currentDialog = action.dialog;
      this.currentProcess = action.process;
      this.currentDialogComponents = action.dialog.components;
    },
    closeDialog() {
      this.currentDialog = null;
      this.currentProcess = null;
      this.currentDialogComponents = null;
    },
    onAccept(formData) {
      this.$emit("executeProcess", {
        formData,
        process: this.currentProcess,
        components: this.currentDialogComponents,
      });
      this.closeDialog();
    },
    isButtonDisabled(action) {
      return action.process.api.path === null;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.func-name {
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .label {
    font-size: 16px;
    font-weight: 600;
    color: black;
    margin: 0;

    /* 1行に制限 */
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .description {
    font-size: 12px;
    font-weight: 400;
    color: gray;
    margin: 0;

    /* 2行に制限 */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.item {
  height: 80px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.item._label {
  flex-basis: 220px;
}

.table-row {
  display: flex;
  justify-content: start;
  align-items: center;
  column-gap: 2rem;
  padding: 10px;
  border-bottom: solid 1px #e2e2e2;
}

.button-component {
  display: flex;
  justify-content: start;
  align-items: center;
  column-gap: 2.5rem;
}
</style>
